import Vue from "vue";
import App from "./App.vue";
import router from "./router/index"; // 방금 만든 router를 가져옵니다.

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
  router,
}).$mount("#app");
